import { useEffect, useState } from 'react';
import {
  getAnalyticsConsent,
  subscribeAnalyticsConsent,
  type AnalyticsConsentStatus,
} from '../utils/analyticsConsent';

/**
 * React binding for the analytics consent store (SEC-6). Returns the current
 * choice (`'granted'` | `'denied'`) or `null` when the visitor has not decided,
 * and re-renders when the choice changes.
 */
export function useAnalyticsConsent(): AnalyticsConsentStatus | null {
  const [status, setStatus] = useState<AnalyticsConsentStatus | null>(() => getAnalyticsConsent());

  useEffect(() => subscribeAnalyticsConsent(setStatus), []);

  return status;
}
